var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormSurge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,58.9v19.7c-2.4-1-5.2-2.7-5.9-4.9c-0.9-2.8-2.1-8.4,3-8.9c0,0-6.4-7.5-11.9,3c-4.1,8-7,11.5-8.9,11.9h-3 c-1.9-0.5-4.8-2.6-5.9-5.9c-0.9-2.8-2.1-8.4,3-8.9c0,0-6.5-7.5-11.9,3c-4.1,8-7,11.5-8.9,11.9h-3c-1.9-0.5-4.8-2.6-5.9-5.9 c-0.9-2.8-2.1-8.4,3-8.9c0,0-6.5-7.5-11.9,3c-4.1,8-7,11.5-8.9,11.9h-3c-1.9-0.5-4.8-2.6-5.9-5.9c-0.9-2.8-2.2-8.4,3-8.9 c0,0-6.5-7.5-11.9,3c-3,5.8-8.4,9.2-11.9,10.8V48C8,25,25.3,5.5,42.9,5.5c9,0,15.5,2,17.8,5.9c2.2,3.7,2.3,10.5-3,11.9 c-2.2,0.6-7.6-1-8.9-3c-0.9-1.4-2.8-2.3,0-5.9C33.3,10.4,21.9,48,57.7,53c4.7-18.2,18.7-32.6,32.6-32.6c6.9,0,10.1,2.9,11.9,5.9 c1.7,2.8,1.1,7.9-3,8.9c-1.7,0.5-5.1-1.3-5.9-3c-0.8-1.7-0.6-4.7,3-5.9C83.8,23.1,75.2,57.2,108.1,58.9L108.1,58.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,79.7c0,0-6.5-7.5-11.9,3c-2.2,4.3-5.8,7.3-8.9,9.2v11.6h106.8v-8.9c-1.9-0.5-7.8-2.6-8.9-5.9c-0.9-2.8-2.1-8.4,3-8.9 c0,0-6.4-7.5-11.9,3c-4.1,8-7,11.5-8.9,11.9h-3c-1.9-0.5-4.8-2.6-5.9-5.9c-0.9-2.8-2.1-8.4,3-8.9c0,0-6.5-7.5-11.9,3 c-4.1,8-7,11.5-8.9,11.9h-3c-1.9-0.5-4.8-2.6-5.9-5.9c-0.9-2.8-2.1-8.4,3-8.9c0,0-6.5-7.5-11.9,3c-4.1,8-7,11.5-8.9,11.9h-3 c-1.9-0.5-4.8-2.6-5.9-5.9C18.2,85.7,17,80.1,22.1,79.7L22.1,79.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormSurge);
export default __webpack_public_path__ + "static/media/storm-surge.2cef8577c5e7388035767878fec6fb9b.svg";
export { ForwardRef as ReactComponent };